import {
  Component,
  HostListener,
  inject,
  OnInit,
  Renderer2,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { SVG_ICONS } from '@shared/constants/google-fonts-icons';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LOGAIA_SVG_ICONS } from '@shared/constants/logaia-icons';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatDialogModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  // Si popup ouverte, ferme celle au premier plan.
  @HostListener('window:keyup.esc', ['$event']) onKeyUp(event: Event) {
    if (this.dialog.openDialogs.length) {
      event.stopImmediatePropagation();
      const componentRef =
        this.dialog.openDialogs[this.dialog.openDialogs.length - 1]
          .componentInstance;
      if (componentRef.closeDialog) {
        componentRef.closeDialog();
      }
    }
  }

  private readonly dialog = inject(MatDialog);
  private readonly paginatorService = inject(MatPaginatorIntl);

  iconRegistry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);
  renderer = inject(Renderer2);

  ngOnInit(): void {
    if (environment.prod) {
      this.renderer.listen('document', 'contextmenu', (evt: PointerEvent) => {
        if ((evt.target as HTMLElement).tagName.toLowerCase() !== 'a') {
          evt.preventDefault();
        }
      });
    }

    // Charge les icones google et Logaia
    SVG_ICONS.forEach((svgIcon) => {
      this.iconRegistry.addSvgIcon(
        svgIcon.iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `public/${svgIcon.filename}`,
        ),
      );
    });

    LOGAIA_SVG_ICONS.forEach((svgIcon) => {
      this.iconRegistry.addSvgIcon(
        svgIcon.iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `public/logaia/${svgIcon.filename}`,
        ),
      );
    });

    // Définie les label pour material paginator.
    this.paginatorService.itemsPerPageLabel = 'Résultats par page';
    this.paginatorService.nextPageLabel = 'Page suivante';
    this.paginatorService.previousPageLabel = 'Page précédente';
    this.paginatorService.getRangeLabel = this.getRangeLabel;
  }

  private getRangeLabel(
    page: number,
    pageSize: number,
    length: number,
  ): string {
    return `${Math.min(page * pageSize + 1, length)} - ${Math.min((page + 1) * pageSize, length)} de ${length}`;
  }
}
